import Vue from './vue';
import t from './i18n';
import formatDate from '../../lib/filters/formatDate';
import store from './vue-store';
import router from '../marketplace/routes';
import ProductCard from '../product-card/ProductCard.vue';

const loadGlobal = () => {
  const el = document.querySelector('#vue-root');
  const els = Array.from(document.querySelectorAll('[data-vue-root]'));
  const roots = [el, ...els].filter(v => v);
  if (!roots.length > 0) return;

  roots.forEach(root => {
    let additionalComponents = {};
    if (root.dataset.vueComponents) {
      for (const [component, loc] of Object.entries(JSON.parse(root.dataset.vueComponents))) {
        additionalComponents[component] = () => import(`../${loc.replace(/^\//, '')}`);
      }
    }

    new Vue({
      el: root,
      comments: true,
      store: store,
      router: router,
      filters: {
        t,
        formatDate
      },
      components: {
        ...additionalComponents,
        ProductCard
      }
    });
  });
};

export default loadGlobal;
